module.exports = __webpack_public_path__ + "img/pic_ljyq@2x.4ecef987.png";